import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras, RouterOutlet, Routes, RouterModule } from '@angular/router';
import { DwRoutingMessageService, AG_GRID_FW_COMPONENT, DwNewRouteKeyService, GetloadingService } from '@webdpt/framework';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FxUrlServiceService } from '../../fxed020-service/fx-url-service.service';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})

export class FooterComponent implements OnInit {
  public footerList: any = []; //销售政策图片
  public friends: any = []; //友情链接
  public footer01: any = []; //页脚栏一
  public footer02: any = []; //页脚栏二
  public footer03: any = []; //页脚栏三
  public helpService: any = []; //帮助中心栏位
  public contactList: any = []; //联系方式
  public qrCode: any = []; //二维码
  public ent: number = null;//获取公共的ent
  constructor(
    public http: FxDapHttpClient,
    public router: DwNewRouteKeyService,
    public route: ActivatedRoute,
    public dwMessage: DwRoutingMessageService,
    private translateService: TranslateService,
    public fxUrlService: FxUrlServiceService,
    private fxUserService: FxUserInfoService,
    public load: GetloadingService
  ) { }

  ngOnInit() {
    // debugger
    this.ent = Number(this.fxUserService.myEnt);
    this.getFooter('admin'); //获取页脚
  }

  getFooter(key: any) {
    const param = {
      "param": {
        "ent": this.ent,
        "c_user": this.fxUserService.userInfo['c_user'],
        "language": this.fxUserService.userInfo['c_lang'],
        "dfb003": this.fxUserService.userInfo['c_cus']
      }
    };
    this.http.post<any>('D/IFxdi405Service/getPageFooterInfo', param).subscribe(
      response => {
        if ( response.data) {
          //console.log(response,'getFooter');
          this.footerList = response.data.dfa1_list;
          this.helpService = response.data.dfa2_list;
          this.friends = response.data.dfa3_list;
          this.footer01 = response.data.dfa6_list;
          this.footer02 = response.data.dfa7_list;
          this.footer03 = response.data.dfa8_list;
          this.contactList = response.data.dfa5_list;
          this.qrCode = response.data.dfa4_list;
          //console.log(this.footerList,'footerList')
        }
        setTimeout(() => {
          this.load.getMask('', false)
        }, 800);
      }, error => {
        throw new error('0000')
      }
    )
  }

  fxAboutlink(e) {
    this.fxUrlService.getDns(e.dfa005, '');
  }

  linkTo(route, param) {
    if (!param) {
      return;
    }
    this.router.navigate([route + '/' + param]);
  }

}
